export default __webpack_public_path__ + "static/media/btnHTPMb.e81661c3.png";